var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C9 7.3 10.3 6 12 6C13.7 6 15 7.3 15 9C15 10.7 13.7 12 12 12C10.3 12 9 10.7 9 9ZM12 14C7.4 14 6 17.3 6 17.3V19H18V17.3C18 17.3 16.6 14 12 14Z",
    fill: "#66676B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11C19.8807 11 21 9.88071 21 8.5C21 7.11929 19.8807 6 18.5 6C17.1193 6 16 7.11929 16 8.5C16 9.88071 17.1193 11 18.5 11Z",
    fill: "#66676B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4992 13C17.2992 13 16.3992 13.3 15.6992 13.8C17.9992 14.9 18.8992 16.8 18.8992 17V17.1H22.9992V15.8C22.9992 15.7 21.8992 13 18.4992 13Z",
    fill: "#66676B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11C19.8807 11 21 9.88071 21 8.5C21 7.11929 19.8807 6 18.5 6C17.1193 6 16 7.11929 16 8.5C16 9.88071 17.1193 11 18.5 11Z",
    fill: "#66676B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4992 13C17.2992 13 16.3992 13.3 15.6992 13.8C17.9992 14.9 18.8992 16.8 18.8992 17V17.1H22.9992V15.8C22.9992 15.7 21.8992 13 18.4992 13Z",
    fill: "#66676B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11C6.88071 11 8 9.88071 8 8.5C8 7.11929 6.88071 6 5.5 6C4.11929 6 3 7.11929 3 8.5C3 9.88071 4.11929 11 5.5 11Z",
    fill: "#66676B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13C6.7 13 7.6 13.3 8.3 13.8C6 14.9 5.1 16.8 5.1 17V17.1H1V15.8C1 15.7 2.1 13 5.5 13Z",
    fill: "#66676B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.cadcf8b682a1af99ddf0e33f3dc77336.svg";
export { ForwardRef as ReactComponent };